import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";

type Props = {
	open: boolean;
	title: string;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
};

/** In-app delete confirm — same Dialog pattern as SignOutConfirm (not window.confirm). */
export function DeleteChatConfirm({
	open,
	title,
	onOpenChange,
	onConfirm,
}: Props) {
	const label = title.trim() || "this chat";

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-md" showCloseButton>
				<DialogHeader>
					<DialogTitle>Delete chat?</DialogTitle>
					<DialogDescription>
						Delete “{label}”? This can’t be undone.
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button
						type="button"
						variant="outline"
						onClick={() => onOpenChange(false)}
					>
						Cancel
					</Button>
					<Button
						type="button"
						variant="destructive"
						onClick={() => {
							onConfirm();
							onOpenChange(false);
						}}
					>
						Delete
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
